// Shared by KaCopyButton and any component that needs to copy text without
// mounting a full KaCopyButton (e.g. a menu item). Throws on failure so
// callers can use their existing try/catch flow.
export async function copyToClipboard(value: string): Promise<void> {
  if (navigator?.clipboard) {
    await navigator.clipboard.writeText(value);
    return;
  }

  const textarea = document.createElement('textarea');
  textarea.value = value;
  textarea.style.position = 'absolute';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  const succeeded = document.execCommand('copy');
  textarea.remove();

  if (!succeeded) {
    throw new Error("document.execCommand('copy') failed");
  }
}
